module.exports = __webpack_public_path__ + "96d933448c492a9c5649b55dfbfde44b.md";